var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card ms-lg-3 mt-2 mb-2 "},[_c('div',{staticClass:"tw_wrap"},[_c('div',{ref:"taiwanContainer",class:{ drag: _vm.switcher },attrs:{"id":"taiwanContainer"}}),_c('div',{staticClass:"tw_switch"})])])}
var staticRenderFns = []

export { render, staticRenderFns }